import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import { isMobileSessionUnlocked, MOBILE_APP_LOGIN_PATH } from '../../utils/mobileApp';

interface MobilePrivateRouteProps {
  children: React.ReactNode;
}

const MobilePrivateRoute: React.FC<MobilePrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated || !isMobileSessionUnlocked()) {
    return <Navigate to={MOBILE_APP_LOGIN_PATH} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default MobilePrivateRoute;
